import React from "react";
import { cn } from "@/lib/utils";

export function ProgressBar({ value = 0, ideal, className }) {
  const v = Math.max(0, Math.min(100, value));
  const fillCls =
    v >= 90 ? "from-emerald-500 to-emerald-400"
    : v >= 50 ? "from-indigo-500 to-purple-500"
    : "from-sky-500 to-indigo-500";
  return (
    <div className={cn("relative h-2.5 w-full rounded-full bg-slate-100 overflow-hidden", className)}>
      <div className={cn("h-full rounded-full bg-gradient-to-r transition-all duration-500", fillCls)} style={{ width: `${v}%` }} />
      {ideal != null && (
        <div className="absolute top-0 h-full w-0.5 bg-slate-400/70" style={{ left: `${Math.min(100, ideal)}%` }} title={`Ideal ${ideal}%`} />
      )}
    </div>
  );
}
